import { MET_ART_RANKING_ITEM } from './met-art-ranking.js'
import { MET_ART_MARGINS_ITEM } from './met-art-margins.js'
import { MET_ART_SALES_ITEM } from './met-art-sales.js'

/** @type {import('../help-index.js').HelpScreen} */
export const MET_ART_HELP = {
  screenId: 'met-art',
  label: 'Productos',
  navPath: 'Métricas → Productos',
  keywords: [
    'ranking productos',
    'margen',
    'rentabilidad',
    'más vendidos',
    'ventas por producto',
    'comparar artículos',
    'métricas productos',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Análisis por artículo: ranking de ventas, márgenes FIFO y comparativo diario de hasta 6 productos.',
  sidebarItems: [MET_ART_RANKING_ITEM, MET_ART_MARGINS_ITEM, MET_ART_SALES_ITEM],
}
